import React from 'react';
import { ChevronDown } from 'lucide-react';

const SYMBOL_PRESETS = [
  { value: 'ALL', label: 'All — SPX, SPY & QQQ', symbols: ['SPX', 'SPY', 'QQQ'] },
  { value: 'SPY_QQQ', label: 'SPY & QQQ', symbols: ['SPY', 'QQQ'] },
  { value: 'SPX', label: 'SPX', symbols: ['SPX'] },
  { value: 'SPY', label: 'SPY', symbols: ['SPY'] },
  { value: 'QQQ', label: 'QQQ', symbols: ['QQQ'] },
];

const PERIOD_OPTIONS = [
  { value: '1D', label: '1 Day' },
  { value: '1W', label: '1 Week' },
  { value: '1M', label: '1 Month' },
  { value: '1Y', label: '1 Year' },
  { value: 'All', label: 'All time' },
  { value: 'Custom', label: 'Custom' },
];

const selectClass =
  'appearance-none bg-gray-800/80 border border-purple-700/40 text-purple-200 text-sm font-medium rounded-full pl-4 pr-9 py-2 cursor-pointer hover:border-purple-500/60 focus:outline-none focus:ring-1 focus:ring-purple-500/40 transition-colors';

const ChartFilters = ({ symbols = ['SPX', 'SPY', 'QQQ'], onChangeSymbols, period = 'All', onChangePeriod }) => {
  const currentPreset =
    SYMBOL_PRESETS.find(
      (p) =>
        p.symbols.length === symbols.length &&
        p.symbols.every((s) => symbols.includes(s))
    )?.value || 'ALL';

  return (
    <div className="flex flex-wrap items-center justify-between gap-3 mb-4">
      <div className="relative">
        <select
          className={selectClass}
          value={currentPreset}
          onChange={(e) => {
            const preset = SYMBOL_PRESETS.find((p) => p.value === e.target.value);
            if (preset && onChangeSymbols) onChangeSymbols(preset.symbols);
          }}
        >
          {SYMBOL_PRESETS.map((p) => (
            <option key={p.value} value={p.value}>
              {p.label}
            </option>
          ))}
        </select>
        <ChevronDown className="pointer-events-none absolute right-3 top-1/2 -translate-y-1/2 w-4 h-4 text-purple-400" />
      </div>

      <div className="relative">
        <select
          className={`${selectClass} text-gray-200`}
          value={period}
          onChange={(e) => onChangePeriod && onChangePeriod(e.target.value)}
        >
          {PERIOD_OPTIONS.map((p) => (
            <option key={p.value} value={p.value}>
              {p.label}
            </option>
          ))}
        </select>
        <ChevronDown className="pointer-events-none absolute right-3 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-400" />
      </div>
    </div>
  );
};

export default ChartFilters;
